/* PublicPromoBadge — fetches /api/promo-codes/public and renders any
 * codes the admin has toggled `surface_on_pricing_page=true`. Renders
 * nothing if no codes are surfaced (so the pricing page stays clean).
 */
import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

function buildLine(p) {
  const parts = [];
  parts.push(`Save ${p.savings_label}`);
  if (p.duration_label) parts.push(p.duration_label);
  parts.push(`with code ${p.code}`);
  let suffix = [];
  if (p.new_customers_only) suffix.push("new customers only");
  if (p.expires_at) {
    try {
      const d = new Date(p.expires_at);
      suffix.push(`expires ${d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })}`);
    } catch { /* ignore */ }
  }
  return { headline: parts.join(" "), suffix: suffix.join(" · ") };
}

export function PublicPromoBadge() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    let cancelled = false;
    fetch(`${BACKEND_URL}/api/promo-codes/public`)
      .then((r) => r.json())
      .then((d) => { if (!cancelled) setItems(d?.items || []); })
      .catch(() => { if (!cancelled) setItems([]); });
    return () => { cancelled = true; };
  }, []);

  if (!items || items.length === 0) return null;

  return (
    <div className="mt-7 space-y-2" data-testid="public-promo-badge">
      {items.map((p) => {
        const { headline, suffix } = buildLine(p);
        return (
          <div
            key={p.code}
            data-testid={`promo-${p.code}`}
            className="flex items-start gap-3 rounded-xl border border-indigo-500/25 bg-gradient-to-br from-indigo-500/10 to-fuchsia-500/[0.04] p-4 text-sm"
          >
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-white/10">
              <Sparkles className="h-4 w-4 text-indigo-300" />
            </div>
            <div className="flex-1">
              <div className="font-medium text-white">{headline}</div>
              {suffix && <div className="mt-0.5 text-xs text-white/55">{suffix}</div>}
            </div>
          </div>
        );
      })}
    </div>
  );
}
